var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { HomePageService } from '~/services/domain-service/home-page.service';
import CaseOverview from './case-overview.vue';
import { Prop } from 'vue-property-decorator';
var CaseOverviewComponent = /** @class */ (function (_super) {
    __extends(CaseOverviewComponent, _super);
    function CaseOverviewComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = {
            caseTotalCount: {
                name: "案件总数",
                color: "light-purple",
                value: 0,
                iconName: 'daiwancheng',
                hidden: []
            },
            newlyCaseCount: {
                name: "今日新增案件数量",
                color: "light-green",
                value: 0,
                iconName: 'xinzenganjian',
                hidden: []
            },
            waitCaseTotalCount: {
                name: "催收案件数量",
                color: "light-purple",
                value: 0,
                iconName: 'daiwancheng',
                hidden: []
            },
            outFlowCaseCount: {
                name: "流出案件数量",
                color: "light-blue",
                value: 0,
                iconName: 'liuchu',
                hidden: []
            },
            carTotalCount: {
                name: "在库车辆",
                color: "light-purple",
                value: 0,
                iconName: 'daiwancheng',
                hidden: ['tel-admin', 'legal-admin']
            },
        };
        return _this;
    }
    CaseOverviewComponent.prototype.updateData = function () {
        var _this = this;
        // 今日新增案件数量
        this.homePageService.getTodayInsertCaseCount({ type: this.menuType }).subscribe(function (data) { return _this.data.newlyCaseCount.value = data; });
        // 催收案件数量
        this.homePageService.getCollectionCaseCount({ type: this.menuType }).subscribe(function (data) { return _this.data.waitCaseTotalCount.value = data; });
        // 流出案件数量
        this.homePageService.getOutCaseCount({ type: this.menuType }).subscribe(function (data) { return _this.data.outFlowCaseCount.value = data; });
        // 案件总数
        this.homePageService.getAllCaseCount({ type: this.menuType }).subscribe(function (data) { return _this.data.caseTotalCount.value = data; });
        // 在线车库
        if (!this.data.carTotalCount.hidden.includes(this.menuType)) {
            this.homePageService.getAllWarehouseCar({ type: this.menuType }).subscribe(function (data) { return _this.data.carTotalCount.value = data; });
        }
    };
    CaseOverviewComponent.prototype.mounted = function () {
        this.updateData();
    };
    __decorate([
        Dependencies(HomePageService)
    ], CaseOverviewComponent.prototype, "homePageService", void 0);
    __decorate([
        Prop()
    ], CaseOverviewComponent.prototype, "menuType", void 0);
    CaseOverviewComponent = __decorate([
        Component({
            components: {
                CaseOverview: CaseOverview
            }
        })
    ], CaseOverviewComponent);
    return CaseOverviewComponent;
}(Vue));
export default CaseOverviewComponent;
